import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { icon } from "../functions/icons"
import { Children, forwardRef, useEffect, useState } from "react"
import { IconButton, MagicButton, StandardButton } from "./buttons"
import { color } from "chart.js/helpers"
import { IconUpload } from "@tabler/icons-react"
import { Spinner } from "./spinner"
import { TextAtom } from "./TextAtom"


export function InputForm({upload, uploadClick,leftImage, rightImage, placeholder, supporting, size, title, style, value, typeInput, rightIcon, action, iconName,generate = false,loading,onClick,disabled, required, onKeyDown,onBlur, password=false, className="" }) {
    return (
        <div onClick={(event) => event.stopPropagation()} onChange={(event) => typeInput(event.target.value)} className={`input-comp input-form ${className}`} data-testid={'input-form'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <HorizontalLayout>
                <input type={password && "password"} onMouseDown={(e) => e.stopPropagation()} onBlur={onBlur} onKeyDown={onKeyDown} className={`standard-input standard-input-form ${size}`} data-testid={'input-form2'} value={value} placeholder={placeholder} disabled={disabled} required={required} onChange={(event) => typeInput(event.target.value)}/>
                {upload && <InputFile className="magic-button video-module-upload" title="" verb="" extraVerb="" accept="video/*" fileChange={uploadClick} icon2="upload" size={"small"} /> }
                {generate && <MagicButton onClick={onClick} loading={loading} />}
            </HorizontalLayout>
            {leftImage && <img data-testid={"image-form1"} alt={'left-img'} />}
            {rightImage && <img data-testid={"image-form1"} alt={'right-img'} />}
            {rightIcon && <div onClick={action} className="input-icon"> {icon(iconName)}</div>}
            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}

        </div>

    )
}

export function TextAreaForm({onKeyDown, readOnly,expand ,collapse, open, aiReload, AI, aiLoading, handleAiGenerate,leftImage, rightImage, placeholder, supporting, size, title, style, value,children, typeInput, rightIcon, action, iconName, textAreaStyle, disabled, classname }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpand = () => {
        if (!expand) return;
        setIsExpanded(!isExpanded);
    }
    return (
        <div onClick={(event) => event.stopPropagation()} onChange={(event) => typeInput(event.target.value)} className={`input-comp text-area ${isExpanded ? "expanded" : ""} ${classname}`} data-testid={'text-area-form'} style={style}>
           {(collapse || title) && <HorizontalLayout className={collapse ? "space-between" : ""} style={{ marginBottom: ".5rem", }} onClick={collapse}>
                 <p className="small-text semi-bold">{title}</p>
                 <div className={open ? "dropdown-chevron open" : "dropdown-chevron closed"}>{collapse && icon("chevron-down", 16)}</div>
            </HorizontalLayout>}
            <div className="task-relative" style={{ position: "relative" }}>
            <textarea onKeyDown={onKeyDown} readOnly={readOnly} onClick={toggleExpand} disabled={disabled} style={textAreaStyle} className={`standard-input ${size} ${AI ? "ai-textarea" : ""}`} data-testid={'input-form2'} placeholder={placeholder} value={value}>{children}</textarea>
             {AI && (<div className={`ai-action ${aiReload ? "ai-refresh" : ""}`}> {aiLoading ? (
              <Spinner size={"25px"} className={"spinner"} style={{ margin: 0 }} />) : (
              <IconButton icon2={aiReload ? "refresh": "wand"} onClick={handleAiGenerate} color={"primary-600"}/> )} </div>)}
            </div>
            {leftImage && <img data-testid={"image-form1"} alt={'left-img'} />}
            {rightImage && <img data-testid={"image-form1"} alt={'right-img'} />}
            {rightIcon && <div onClick={action} className="input-icon"> {icon(iconName)}</div>}
            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>

    )
}

export function DateInputForm({ title, style, onChange, value }) {
        const today = new Date().toISOString().split("T")[0];
  return (
    <div className="input-comp" style={style}>
      <label>
        <p className="small-text semi-bold">{title}</p>
        <input
          type="date"
          min={today}
          value={value || today}
          onChange={e => onChange && onChange(e.target.value)}
        />
      </label>
    </div>
  );
}


export function SimpleTextAreaForm({ title, placeholder, value, onChange, supporting, aiLoading, handleAiGenerate,}) {
  return (
    <div className="simple-textarea-form" onClick={(event) => event.stopPropagation()}>
      {title && <p className="small-text semi-bold standard-small-margin-bottom">{title}</p>}
      <div className="textarea-wrapper">
        <textarea
          className="form-textarea"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          rows={4}
        />

        {handleAiGenerate && (<MagicButton onClick={handleAiGenerate} loading={aiLoading} style={{ position: "absolute", bottom: "1rem", right: "1rem", backgroundColor: "transparent", border: "0"}} />)}
      </div>

      {supporting && <p className="supporting-text">{supporting}</p>}
    </div>
  );
}


export function SelectInputForm({ leftImage, rightImage, placeholder, supporting, size, title, style, typeInput, options, onChange, value }) {
    return (
        <div className={`input-comp`} data-testid={'select-input-form'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <div className="select-container">
            <select onChange={(event) => onChange(event.target.value)} className={`standard-input ${size}`} data-testid={'select-form'} placeholder={placeholder} value={value}>
                    {options}
            </select>
            </div>

            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>

    )

}

export function CustomSelectinputForm({ 
    options = [], 
    onChange, 
    placeholder = "Selecteer", 
    defaultValue, 
    size = "", 
    title, 
    supporting, 
    style 
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(
        options.find(o => o.value === defaultValue) || null
    );

    const handleSelect = (option) => {
        setSelected(option);
        onChange(option.value);
        setIsOpen(false);
    };

    return (
        <div className={`input-comp`} data-testid={'custom-select-input'} style={style}>
            {title && <p className="small-text semi-bold">{title}</p>}

            <div className="select-container">
                <div style={{ width: "auto" }} className={`standard-input ${size} custom-select-options`} onClick={() => setIsOpen(!isOpen)}>
                    <span>{selected ? selected.label : placeholder}</span>
                </div>
                {isOpen && (
                    <div
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            border: "1px solid var(--border-color)",
                            borderRadius: "6px",
                            background: "var(--primary-50)",
                            zIndex: 1000,
                            maxHeight: "9.5rem",
                            overflowY: "auto",
                        }}
                    >
                        {options.map(opt => (
                            <div
                                key={opt.value}
                                onClick={() => handleSelect(opt)}
                                className="custom-select-option"
                                style={{
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    borderBottom: "1px solid var(--divider-border-color)",
                                }}
                            >
                                <div className="option-title" style={{ fontWeight: 500 }}>{opt.label}</div>
                                {opt.sub && <div className="option-sub" style={{ fontSize: "12px", color: "#666" }}>{opt.sub}</div>}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {supporting && <p className="xsmall-text supporting-text grey-600">{supporting}</p>}
        </div>
    );
}


export function QuizSelectForm({ leftImage, rightImage, placeholder, supporting, size, title, style, typeInput, options, setQuizType, selectedValue }) {
    console.log("QuizSelectForm selectedValue:", selectedValue);
    return (
        <div className={`input-comp`} data-testid={'quiz-select-form'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <div className="select-container">
                <select value={selectedValue} onChange={(event) => setQuizType(event.target.value)} className={`standard-input ${size}`} data-testid={'select-form'} placeholder={placeholder}>
                    {options}
                    <option value={1}>Multiplechoice</option>
                    <option value={2}>Match antwoorden</option>
                    <option value={3}>Waar / niet waar</option>
                    <option value={4}>Rangschikken</option>
                    <option value={5}>Kies foto/afbeelding</option>
                    <option value={6}>Openvraag</option>
                    <div style={{ position: "absolute", right: "0" }}>{icon('arrow-right')}</div>
                </select>
            </div>

            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>

    )
}

export function QuizTimeUnit({ leftImage, rightImage, placeholder, supporting, size, title, style, typeInput, options, setTime, value }) {
    return (
        <div className={`input-comp`} data-testid={'quiz-time-unit'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <div className="select-container">
                <select value={parseInt(value)} onChange={(event) => setTime(event.target.value)} className={`standard-input ${size}`} data-testid={'select-form'} placeholder={placeholder} >
                    {options}
                    <option value={-1}>Geen tijdslimiet</option>
                    <option value={1}>1 minuut</option>
                    <option value={2}>2 minuten</option>
                    <option value={3}>3 minuten</option>
                    <option value={5}>5 minuten</option>
                    <option value={10}>10 minuten</option>
                    <option value={15}>15 minuten</option>
                    <option value={30}>30 minuten</option>
                    <div style={{ position: "absolute", right: "0" }}>{icon('arrow-right')}</div>
                </select>
            </div>

            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>

    )
}

export function QuizWeight({ leftImage, rightImage, placeholder, supporting, size, title, style, typeInput, options, setWeight,value }) {
    return (
        <div className={`input-comp`} data-testid={'quiz-weight'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <div className="select-container">
                <select value={value} onChange={(event) => setWeight(event.target.value)} className={`standard-input ${size}`} data-testid={'select-form'} placeholder={placeholder}>
                    {options}
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <div style={{ position: "absolute", right: "0" }}>{icon('arrow-right')}</div>
                </select>
            </div>

            {supporting && <p data-testid={'sup porting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>

    )
}

export const InputFile = forwardRef(({ leftImage, rightImage, fileChange, placeholder, supporting, size, title, style, icon2, verb, extraVerb,accept, className = "" }, ref) => {
    const [fileName, setFileName] = useState("");

    const handleFileChange = (event) => {
        fileChange(event)
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
        } else {
            setFileName("");
        }
    };
    return (
        <div className={`input-comp ${className}`} data-testid={'input-file'} style={style}>
            <p className="small-text semi-bold">{title}</p>
            <div className="file-container">
                <input ref={ref} accept={accept} type={"file"} className={`input-file ${size}`} data-testid={'select-form'} placeholder={placeholder} onChange={handleFileChange} />
                <VerticalLayout style={{ width: "unset", "alignItems": 'center', padding: "1rem" }}>
                    <div className="icon-upload standard-rounded primary-background-100 standard-padding standard-margin">
                        {icon(icon2)}
                    </div>
                    <p className="standard-text-color">{verb}</p>
                    <p className="standard-text-color-light">{extraVerb}</p>
                    {fileName && <p className="file-name standard-text-color">{fileName}</p>}
                </VerticalLayout>
            </div>

            {supporting && <p data-testid={'supporting-text1'} className={`xsmall-text supporting-text grey-600`}>{supporting}</p>}
        </div>  
    );
});
export function ColorPickerForm({ supporting, selectedColors, setSelectedColors, confirmColor }) {
    const handleColorChange = (index, value) => {
        const newColors = [...selectedColors];
        newColors[index] = value.startsWith("#") ? value : "#" + value;
        setSelectedColors([newColors[0], newColors[1]]);
    };
    return (
        <VerticalLayout>
            {supporting && (   <p className="xsmall-text supporting-text grey-600">{supporting}</p>)}
            <ColorSelector colors={selectedColors} handleColorChange={handleColorChange} />
            <StandardButton
                style={{ marginTop: "1rem", marginLeft:"auto",  }}
                title={"Opslaan"}
                onClick={() => confirmColor({ colors: [selectedColors[0], selectedColors[1]] })}
            />
        </VerticalLayout>
    );
}

const ColorSelector = ({ colors, handleColorChange }) => {
    console.log("ColorSelector colors:", colors);
    return (    
        <>
            <HorizontalLayout
                className="space-between"
                style={{ gap: "1rem", margin: ".5rem 0", width: "100%" }}
            >
                {colors.map((color, index) => (
                    <input
                        key={index}
                        type="color"
                        value={color.slice(0, 7)} 
                        onChange={(e) => handleColorChange(index, e.target.value + "ff")}
                        style={{
                            width: "60px",
                            height: "60px",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer",
                            boxShadow: "0 0 4px rgba(0,0,0,0.15)",
                        }}
                    />
                ))}
            </HorizontalLayout>
            <TextAtom className={"small-text bold standard-small-margin-top"} title={"Preview:"} />
            <div
                style={{
                    width: "100%",
                    height: "80px",
                    borderRadius: "8px",
                    background: `radial-gradient(circle 20rem at 50% 50%, ${colors[0]}, ${colors[1]} 90%)`,
                    border: "1px solid var(--grey-300)",
                    boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                }}
            />
        </>
    );
};